import type { RegistrationMode, User } from '../types/api';
import { apiRequest } from './client';

interface AuthResponse {
  user: User;
  registrationMode?: RegistrationMode;
  googleAuthEnabled?: boolean;
}

export type AuthCredentials = {
  email: string;
  password: string;
  displayName?: string;
  inviteCode?: string;
};

export const authApi = {
  me: () => apiRequest<AuthResponse>('/api/auth/me'),
  login: (credentials: AuthCredentials) => apiRequest<AuthResponse>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials)
  }),
  register: (credentials: AuthCredentials) => apiRequest<AuthResponse>('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify(credentials)
  }),
  logout: () => apiRequest<{ ok: true }>('/api/auth/logout', {
    method: 'POST',
    body: '{}'
  })
};
